
import { connect } from 'react-redux'
import { compose, branch, renderComponent, renderNothing } from 'recompose'
import Email from './Email'

const Component = compose(

  connect(state => {
    return {
      items: state.breadcrumb
    }
  }),
  branch(
    () => {
      return true
    },
    renderComponent(Email),
    renderNothing
  )
)(Email)

export default Component